import React from 'react';
import Header from "../../../components/Header";
import {Box} from '@mui/material';
import { createGlobalStyle } from 'styled-components';
import Cotacao from '../../../components/Cotacao';
import Footer from '../../../components/Footer';

const GlobalStyle = createGlobalStyle`
  body, html {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%; 
    overflow-x: hidden;
    overflow-y: auto;
  }
`;

function Home() {
  return (
    <div style={{ backgroundColor: '#f0f0f0', minHeight: '100vh', position: 'relative' }}>
      <GlobalStyle />
      <Header />

   

      <Box sx={{ padding: '20px' }}>
       
      <Cotacao
              serviceId="service_zky97ij" 
              templateId="template_7luh384" 
              userId="K6sXHa7DR1iJvD8GU" 
            colaborador="Cesar Marçal"/>
      </Box>

      <Footer />
    </div>
  );
}

export default Home;
